import { httpClientBackend as service } from "./Service";
import { objToQuery } from "../mixins/helpers";

const END_POINT = "/entities/categories";

const getAllCategories = (data) => {
  return service.get(END_POINT + objToQuery(data));
};

const getCategoryById = (id) => {
  return service.get(END_POINT + "/by-id/" + id);
};

const searchCategories = (searchTerm, query) => {
  return service.get(
    END_POINT +
      "/basic-search/" +
      encodeURIComponent(searchTerm) +
      objToQuery(query)
  );
};

const createCategory = (data) => {
  return service.post(END_POINT, data);
};

const updateCategory = (id, data) => {
  return service.put(END_POINT + "/" + id, data);
};

const deleteOneCategory = (id) => {
  return service.delete(END_POINT + "/hard-delete-one/" + id);
};

const deleteMultipleCategories = (data) => {
  return service.delete(END_POINT + "/hard-delete-multiple", {
    data: JSON.stringify({ ids: data.ids }),
  });
};

const mergeCategories = (data) => {
  return service.post(
    END_POINT + "/merge",
    JSON.stringify({ mainId: data.mainId, otherIds: data.otherIds })
  );
};

export {
  getAllCategories,
  getCategoryById,
  searchCategories,
  createCategory,
  updateCategory,
  deleteOneCategory,
  deleteMultipleCategories,
  mergeCategories,
};
